import React from "react";
import { CharacterHistory } from "../classes/CharacterHistory";

const characterHistoryInitial: CharacterHistory = {
  revisionHistory: [],
  revisionNumber: 0,
} as any;

export const CharacterHistoryContext = React.createContext(
  characterHistoryInitial
);
